import { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { EmptyValue } from "@bcc/components/ui/empty-value";
import { VariantWithProductData } from "../types";
import { setVariantsCellTestId } from "../products-table.utils";

export const VariantsCellMarkup = (props: CellContext<VariantWithProductData, unknown>) => {
  const { t } = useTranslation();
  const data = props.row.original;
  const grindCount = data.grind?.length ?? 0;

  return (
    <span className="text-sm text-muted-foreground" data-testid={setVariantsCellTestId(props.row.index)}>
      {grindCount > 0 ? t("views.productsTable.grinds", { count: grindCount }) : <EmptyValue />}
    </span>
  );
};
